import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { mountSandboxedHtml } from '@/lib/sandboxedAd';

/**
 * AdCode component that safely renders admin-configured HTML ad codes.
 * Scripts run inside sandboxed iframes (no top-level redirect possible) -
 * see /app/frontend/src/lib/sandboxedAd.js.
 */
const AdCode = ({ code, className = '' }) => {
  const containerRef = useRef(null);
  const location = useLocation();
  const [renderKey, setRenderKey] = useState(0);

  // Force re-render on route change to re-execute ad scripts
  useEffect(() => {
    setRenderKey(prev => prev + 1);
  }, [location.pathname]);

  useEffect(() => {
    if (!code || !containerRef.current) return;
    const cleanup = mountSandboxedHtml(containerRef.current, code);
    return cleanup;
  }, [code, renderKey]);

  if (!code) return null;

  return (
    <div
      ref={containerRef}
      className={className}
      data-testid="ad-code-container"
    />
  );
};

export default AdCode;
